// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @12.09.2017 13:53:38
import { GetParentOwnerRequest_abstract } from './../abstract/SagaBase/GetParentOwnerRequest_abstract';
export class GetParentOwnerRequest extends GetParentOwnerRequest_abstract {}
